import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SearchIcon from '../../../assets/icons/table/search.svg';

const ReceiverModal = ({
  receiverData,
  signageId,
  resetModal
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  useEffect(() => {
    const modalElement = document.getElementById('receiverModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  const receiverList = receiverData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );
  return (
    <div className='modal modal-mse fade' id='receiverModal' tabIndex='-1' aria-labelledby='receiverModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='VIEW_RECEIVERS' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body' style={{ padding: '0px' }}>
            <div className='row' style={{ backgroundColor: 'rgba(233, 243, 252, 1)', padding: '15px' }}>
              <div id="search" className="form-outline search-container h-100 ms-auto position-relative" style={{ height: 'auto', width: '100%' }}>
                <input
                  id="searchInput"
                  className="form-control"
                  type="search"
                  placeholder={t("SEARCH")}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <img src={SearchIcon} className="searchIcon position-absolute" alt="Search Icon" style={{ top: '20px' }} />
              </div>
            </div>
            <ul className="list-group flex-scroll">
              {receiverList.map((item) => (
                <li
                  className="list-group-item d-flex align-items-center justify-content-between"
                  style={{
                    height: '64px',
                    cursor: 'pointer'
                  }}
                  key={signageId + "-" + item.mac}
                >
                  <div className="d-flex align-items-center">
                    <span >{item.name}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiverModal;
